import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function AccountStatusExtUpsert(param: any) {

    let [accountExtStatus, setAccountExtStatus] = useState<any>(param?.editDataDawer ?? []);

    const closeDrawer = () => { param.closeDrawer() }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            accountExtStatus = param?.editDataDawer
            setAccountExtStatus(accountExtStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveStatusAccountExt(accountExtStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Account Status Ext Saved', 'Success')
        })
    }

    return (<>

        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll ' size={800}>

            <div className="pull-right ws-5 box full-height-vh">

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Account Status Ext</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-12">
                            <div className="form-format">
                                <label className="control-label">Account Status Ext UseID</label>

                                <div className="label-entries">
                                    <input type="number" placeholder="Account Status Ext Use ID" data-ng-model="accountStatusExt.acctStatusExtUseID" id="acctStatusExtUseID" ng-disabled="IsDisabled" name="acctStatusExtUseID" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Account Status Ext Parent</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Account Status Ext Parent" data-ng-model="accountStatusExt.acctStatusExtParent" id="acctStatusExtParent" name="acctStatusExtParent" />
                                </div>
                            </div>

                            <div className="form-format">
                                <label className="control-label">Account Status Ext Name </label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Account Status Ext Name" data-ng-model="accountStatusExt.acctStatusExtName" id="acctStatusExtName" name="acctStatusExtName" />
                                </div>
                            </div>
                            <div className="form-format">
                                <label className="control-label">Account Status Ext Short Code</label>
                                <div className="label-entries">
                                    <input type="text" placeholder="Account Status Ext Short Code" data-ng-model="accountStatusExt.acctStatusExtShortCode" id="acctStatusExtShortCode" name="acctStatusExtShortCode" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 mt">
                            <div className="ws-6">
                                <div className="mbl">
                                    RecMYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.recMYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.recMYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.recMYN =='1'">No</span> </label>
                                </div>

                                <div className="mbl">
                                    PublYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.publYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.publYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.publYN =='1'">No</span> </label>
                                </div>

                                <div className="mbl">
                                    MechYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.mechYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.mechYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.mechYN =='1'">No</span> </label>
                                </div>

                                <div className="mbl">
                                    ApprovalYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.approvalYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.approvalYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.approvalYN =='1'">No</span>
                                    </label>
                                </div>
                            </div>

                            <div className="ws-6">

                                <div className="mbl">
                                    ControlRptYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.controlRptYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.controlRptYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.controlRptYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    EmailYN
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.emailYN" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.emailYN=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.emailYN =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    AutoLTD
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.autoLTD" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.autoLTD=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.autoLTD =='1'">No</span>
                                    </label>
                                </div>

                                <div className="mbl">
                                    IsDefault
                                    <label className="switch mr">
                                        <input type="checkbox" ng-checked="checkbox == 1" data-ng-model="accountStatusExt.isDefault" />
                                        <span className="slider round text-left white pm pts " ng-show="accountStatusExt.isDefault=='1'">Yes</span>
                                        <span className="slider round text-right white pm pts sliderOff" ng-show="!accountStatusExt.isDefault =='1'">No</span>
                                    </label>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">

                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}